// Mensajes de UI para la verificación de entregabilidad de emails (BounceBan):
// resultado de una verificación puntual y errores HTTP del endpoint.
import { getVerificationResultLabel } from "./verificationLabels";
import { describeRequestError } from "./requestErrorMessage";

export const VERIFICATION_PENDING_MESSAGE =
  "BounceBan está tardando más de lo esperado en procesar la solicitud. Te vamos a enviar una notificación cuando termine.";

export function isVerificationPending(result) {
  return result?.status === "verifying";
}

export function buildVerifyResultMessage(result) {
  return [
    result.result
      ? `Resultado: ${getVerificationResultLabel(result.result)}${
          result.score != null ? ` (score ${result.score})` : ""
        }.`
      : result.is_verified
        ? "El email es entregable."
        : "El email no es entregable.",
    result.credits_consumed == null
      ? "Se consumieron créditos de validación."
      : result.credits_consumed === 1
        ? "Se consumió 1 crédito."
        : `Se consumieron ${result.credits_consumed} créditos.`,
  ].join(" ");
}

export function getVerifyErrorMessage(err) {
  const statusCode = err?.response?.status;
  if (statusCode === 402) {
    return "Sin créditos de validación disponibles. Podés recargar desde Configuración → Créditos.";
  }
  if (statusCode === 400) {
    return err.response?.data?.detail ?? "No se pudo verificar el email.";
  }
  if (statusCode === 403) {
    return describeRequestError(err, "No se pudo verificar el email");
  }
  if (statusCode === 502) {
    return "Error al verificar. Intentá de nuevo.";
  }
  return "Ocurrió un error inesperado. Intentá de nuevo.";
}
